var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{staticClass:"my-3",attrs:{"width":10,"size":100,"indeterminate":"","color":"#ff7516"}}),_vm._v(" "),_c('span',{staticClass:"d-block text-center"},[_vm._v("Loading")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }